module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/unauthorized/noaccess.component.sass
// module id = ./src/app/unauthorized/noaccess.component.sass
// module chunks = main